export default "__VITE_ASSET__aac48db0__"